import dynamic from 'next/dynamic'
import { ReactNode, useEffect, useState } from 'react'
const ReactMarkdown = dynamic<any>(
  () => import('react-markdown').then(m => m.default),
  { ssr: false }
)

type Props = {
  children?: ReactNode
  className?: string
  onLoad?: VoidFunction
}

export const Markdown = ({ children, className, onLoad }: Props) => {
  const [plugins, setPlugins] = useState<{ remarkGfm: any; rehypeRaw: any }>({
    remarkGfm: null,
    rehypeRaw: null,
  })

  useEffect(() => {
    const loadPlugins = async () => {
      const remarkGfm = (await import('remark-gfm')).default
      const rehypeRaw = (await import('rehype-raw')).default

      return { remarkGfm, rehypeRaw }
    }

    loadPlugins()
      .then(plugins => {
        setPlugins(plugins)
        onLoad?.()
      })
      .catch(console.error)
  }, [])

  if (!plugins?.remarkGfm || !plugins?.rehypeRaw) return null

  return (
    <ReactMarkdown
      remarkPlugins={[plugins.remarkGfm]}
      rehypePlugins={[plugins.rehypeRaw]}
      className={className}
    >
      {children}
    </ReactMarkdown>
  )
}
